<template>
    <div class="owners-insurance-accordion">
        <Accordion
            class="vehicle-insurance-accordion"
            :items="ownersInsuranceItems"
            :allow-multiple-open="false"
            slot-key="key"
        >
            <template #header-desc-comprehensive_insurance="{ item }">
                {{ item.priceLabel }}
            </template>
            <template #item-comprehensive_insurance>
                <ul>
                    <li v-if="vehicle.insuranceCompany">
                        {{
                            $t('pages.booking_request.insurance_step.owners_insurance.list_item1', {
                                companyName: vehicle.insuranceCompany,
                            })
                        }}
                    </li>
                    <li v-if="vehicle.deductible">
                        {{
                            $t('pages.booking_request.insurance_step.deductible', {
                                price: formattedPrice(vehicle.deductible, vehicle.currency),
                            })
                        }}
                    </li>
                    <li v-if="vehicle.insurancePolicyUrl">
                        <a :href="vehicle.insurancePolicyUrl" target="_blank">
                            {{ $t('pages.booking_request.insurance_step.owners_insurance.list_item2') }}
                        </a>
                    </li>
                    <li v-if="vehicle.insuranceTermsUrl">
                        <a :href="vehicle.insuranceTermsUrl" target="_blank">
                            {{ $t('pages.booking_request.insurance_step.owners_insurance.list_item3') }}
                        </a>
                    </li>
                </ul>
            </template>

            <template #header-desc-roadside_assistance="{ item }">
                {{ item.priceLabel }}
            </template>
            <template
                v-if="vehicle.roadsideAssistanceName || vehicle.roadsideAssistancePhone"
                #item-roadside_assistance
            >
                <ul>
                    <li v-if="vehicle.roadsideAssistanceName">
                        {{
                            $t('pages.booking_request.insurance_step.owners_roadside_assistance.list_item1', {
                                companyName: vehicle.roadsideAssistanceName,
                            })
                        }}
                    </li>
                    <li v-if="vehicle.roadsideAssistancePhone">
                        {{
                            $t('pages.booking_request.insurance_step.owners_roadside_assistance.list_item2', {
                                phone: vehicle.roadsideAssistancePhone,
                            })
                        }}
                    </li>
                </ul>
            </template>
        </Accordion>

        <BaloiseInsuranceOptions
            v-if="baloiseInsuranceItems.length > 0"
            :items="baloiseInsuranceItems"
            :vehicle="vehicle"
        />
    </div>
</template>

<script>
import Accordion from '~/components/Accordion';
import BaloiseInsuranceOptions from '~/components/vehicle/BaloiseInsuranceOptions';
import { BALOISE_ID } from '~/config/insurance';

export default {
    name: 'OwnersInsuranceOptions',
    components: { BaloiseInsuranceOptions, Accordion },
    props: {
        vehicle: {
            type: Object,
            required: true,
        },
        items: {
            type: Array,
            required: true,
        },
    },
    computed: {
        ownersInsuranceItems() {
            return this.items.filter(item => item.vendor !== BALOISE_ID);
        },
        baloiseInsuranceItems() {
            return this.items.filter(item => item.vendor === BALOISE_ID);
        },
    },
};
</script>

<style scoped lang="scss">
.owners-insurance-accordion {
    ::v-deep .baloise-insurance-accordion {
        margin-top: 16px;
    }
}
</style>
